import React from 'react';
import { CopyOutlined } from '@ant-design/icons';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { message } from 'antd';

export const BlockHeader = ({ icon = null, title, alignTextLeft, copyData = null, className = '', extra = null }) => {
  return (
    <>
      <div
        className={`block-header ${className}`}
        style={{ pageBreakInside: 'avoid', pageBreakAfter: 'auto', width: '100%' }}
      >
        {icon}
        <span className={icon ? 'block-header-span-icon' : !alignTextLeft && 'block-header-span-no-icon'}>{title}</span>
        {copyData ? (
          <CopyToClipboard text={copyData} onCopy={() => message.success('Text copied to clipboard!', 2)}>
            <CopyOutlined />
          </CopyToClipboard>
        ) : null}
      </div>
      {extra}
    </>
  );
};
